import { Navigate, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import AuthGuard from './components/AuthGuard';
import Layout from './components/Layout';
import Checkout from './pages/Checkout';
import MoneroCheckout from './pages/MoneroCheckout';
import Overview from './pages/Overview';
import Transactions from './pages/Transactions';
import Crm from './pages/Crm';
import Invoices from './pages/Invoices';
import Contracts from './pages/Contracts';
import Receipts from './pages/Receipts';
import Files from './pages/Files';
import Mercury from './pages/Mercury';
import PayPal from './pages/PayPal';
import Stripe from './pages/Stripe';
import Chain2Pay from './pages/Chain2Pay';
import Crypto from './pages/Crypto';
import Assets from './pages/Assets';
import Tax from './pages/Tax';
import Backups from './pages/Backups';
import Admin from './pages/Admin';
import ApiDocs from './pages/ApiDocs';
import McpConsole from './pages/McpConsole';
import AiConsole from './pages/AiConsole';
import Approvals from './pages/Approvals';
import Webhooks from './pages/Webhooks';
import EmbedApp from './pages/EmbedApp';
import NotFound from './pages/NotFound';
import SecureFormPublic from './pages/SecureFormPublic';

const isCheckoutMode =
  import.meta.env.VITE_CHECKOUT_MODE === 'true' ||
  (typeof window !== 'undefined' && window.location.hostname === 'pay.zerotail.org');

function CheckoutApp() {
  return (
    <div className="min-h-screen bg-zt-bg text-slate-200">
      <Toaster
        position="top-right"
        toastOptions={{
          className: 'bg-zt-surface text-slate-200 border border-zt-border',
        }}
      />
      <Routes>
        <Route path="/" element={<Checkout />} />
        <Route path="/p/:token/monero" element={<MoneroCheckout />} />
        <Route path="/p/:token" element={<Checkout />} />
        <Route path="/pay/:token/monero" element={<MoneroCheckout />} />
        <Route path="/pay/:token" element={<Checkout />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

function DashboardApp() {
  return (
    <div className="min-h-screen bg-zt-bg text-slate-200">
      <Toaster
        position="top-right"
        toastOptions={{
          className: 'bg-zt-surface text-slate-200 border border-zt-border',
        }}
      />
      <Routes>
        {/* Public token-gated secure forms (no operator session). */}
        <Route path="/secure-form/:token" element={<SecureFormPublic />} />
        <Route path="/f/:token" element={<SecureFormPublic />} />

        <Route
          path="/*"
          element={
            <AuthGuard>
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<Navigate to="/ai" replace />} />
                  <Route path="overview" element={<Overview />} />
                  <Route path="transactions" element={<Transactions />} />
                  <Route path="crm" element={<Crm />} />
                  <Route path="invoices" element={<Invoices />} />
                  <Route path="contracts" element={<Contracts />} />
                  <Route path="receipts" element={<Receipts />} />
                  <Route path="files" element={<Files />} />
                  <Route path="mercury" element={<Mercury />} />
                  <Route path="paypal" element={<PayPal />} />
                  <Route path="stripe" element={<Stripe />} />
                  <Route path="chain2pay" element={<Chain2Pay />} />
                  <Route path="crypto" element={<Crypto />} />
                  <Route path="assets" element={<Assets />} />
                  <Route path="tax" element={<Tax />} />
                  <Route path="backups" element={<Backups />} />
                  <Route path="admin" element={<Admin />} />
                  <Route path="api-docs" element={<ApiDocs />} />
                  <Route path="mcp" element={<McpConsole />} />
                  <Route path="ai" element={<AiConsole />} />
                  <Route path="ai/:conversationId" element={<AiConsole />} />
                  <Route path="approvals" element={<Approvals />} />
                  <Route path="webhooks" element={<Webhooks />} />
                  <Route path="embed/:appKey" element={<EmbedApp />} />
                  <Route path="checkout" element={<Checkout />} />
                </Route>
                <Route path="*" element={<NotFound />} />
              </Routes>
            </AuthGuard>
          }
        />
      </Routes>
    </div>
  );
}

function App() {
  return isCheckoutMode ? <CheckoutApp /> : <DashboardApp />;
}

export default App;
